import 'jquery.cookie';
var home = {};

(function (homeApp) {
	var localTag = "";
	var cookieName = "_oa_localCk";
	var campaignTag = "";
	var excludeEventIds = $('#appearedEventsIds').val() + ',' + $('#homeEventIds').val();
	var excludeArticleIds = $('#appearedArticlesIds').val();

	homeApp.GetSearchResults = function (isLoadCampaignTag = false) {
		$.ajax({
			url: `/umbraco/surface/LocalSurface/GetHomeLocalSearchResults?localTag=${localTag}&excludeArticleIds=${excludeArticleIds}&excludeEventIds=${excludeEventIds}`,
			type: "POST",
			dataType: "html",
			success: function (data) {
				$(".home-local-items").html(data);
			},
			complete: function () {
				if (isLoadCampaignTag && $('#campaignTag').length > 0) {
					campaignTag = $('#campaignTag').val();
					homeApp.GetCampaign();
				}
			}
		});
	};

	homeApp.GetCampaign = function () {
		const campaignExcludeEventIds = excludeEventIds + ',' + $('#localEventsIds').val();
		const campaignExcludeArticleIds = excludeArticleIds + ',' + $('#localArticlesIds').val();

		$.ajax({
			url: `/umbraco/surface/TagSurface/GetHomeCampaign?tag=${campaignTag}&excludeArticleIds=${campaignExcludeArticleIds}&excludeEventIds=${campaignExcludeEventIds}`,
			type: "POST",
			dataType: "html",
			success: function (data) {
				$(".hero-campaign .article-grid-wrapper").html(data);
			}
		});
	};

	homeApp.UpdateViewMoreLocalLink = function (oldTag, newTag) {
		$("a.view-more-local").attr("href", $("a.view-more-local").data("localpage") + (newTag !== '' ? '/?local=' + newTag : ''));
	}

	$(document).ready(function () {
		localTag = $.cookie(cookieName) || '';
		homeApp.GetSearchResults(true);
		$("#tag-select").val(localTag);
		homeApp.UpdateViewMoreLocalLink('', localTag);
		//on location dropown change
		$("#tag-select").change(function () {
			homeApp.UpdateViewMoreLocalLink(localTag, this.value);
			localTag = this.value;
			homeApp.GetSearchResults();
			//set cookie for localTag
			$.cookie(cookieName, localTag, { expires: 365, path: '/' });
		});
	});

})(home);
